import axios from 'axios';
import URL from './URLString';

const instance = axios.create({
    baseURL: URL,
    withCredentials: true,
    timeout: 15000, // 15 seconds timeout
    timeoutErrorMessage: 'Request timed out, please try again later',
});

// Add request interceptor for handling errors
instance.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        console.error("Request error:", error);
        return Promise.reject(error);
    }
);

// Add response interceptor for handling errors
instance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.code === 'ECONNABORTED') {
            console.error("Request timeout:", error);
            handleSessionError("Network timeout. Please try again.");
        } else if (error.response) {
            console.error("Response error:", error.response.status, error.response.data);
            
            // Handle authentication errors (401 Unauthorized, 403 Forbidden)
            if (error.response.status === 401 || 
                error.response.status === 403 || 
                (error.response.data && 
                 (error.response.data.error === "auth" || 
                  error.response.data.error === "invalid token" || 
                  error.response.data.error === "Adminnotsubscribed"))) {
                handleSessionError("Session expired. Please sign in again.");
            }
        } else if (error.request) {
            console.error("No response received:", error.request);
            handleSessionError("Server not responding. Please try again later.");
        } else {
            console.error("Request configuration error:", error.message);
        }
        return Promise.reject(error);
    }
);

// Function to handle session errors and redirect to sign in
const handleSessionError = (message) => {
    // Clear local storage
    localStorage.removeItem("adminData");
    localStorage.removeItem("customerData");
    localStorage.removeItem("staffData");
    
    // If we're not already on the sign-in page, redirect
    if (window.location.pathname !== "/" && window.location.pathname !== "/signin") {
        // Optional: Show an alert or toast notification
        if (message) {
            alert(message);
        }
        
        // Redirect to sign-in page
        window.location.href = "/";
    }
};

export default instance;